import {UPDATE_NATURE_MAGAZINE_START} from "../../types";

export const update_nature_magazine = (payload) => ({
    type: UPDATE_NATURE_MAGAZINE_START,
    payload,
});
